import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

export interface PaymentReconciliationResponse {
  data: PaymentReconciliationData[];
  meta: {
    totalRowCount: number;
  };
}

export interface PaymentReconciliationData {
  id: string;
  merchantEmail: string;
  amount: string;
  currency: string;
  quantitySold: number;
  transactionId: string;
  transactionDate: string;
  status: string;
  isPaymentReceived: boolean;
  isInventorySent: boolean;
  createdAt: string;
  upcId: string;
  failedReason: string;
  updatedAt: string;
  amountToTransferFromMerchant: string;
  isNoteIssued: boolean;
  upcUnitSellingPrice: string;
  paymentProviderRef: string;
}

interface PaymentReconciliationRequest {
  token: string;
  pagination: MRT_PaginationState;
  columnFilters: MRT_ColumnFiltersState;
  sorting: MRT_SortingState;
}

const getPaymentReconciliationData = async ({
  token,
  pagination,
  columnFilters,
  sorting,
}: PaymentReconciliationRequest): Promise<PaymentReconciliationResponse> => {
  try {
    const response = await axios.get(
      `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-repayment/get-payment-reconciliation-data`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: `${pagination.pageIndex + 1}`,
          pageSize: `${pagination.pageSize}`,
          columnFilters,
          sorting: sorting,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getPaymentReconciliationData;
